import { render, staticRenderFns } from "./ApprovalsFilter.vue?vue&type=template&id=647fb95a&scoped=true"
import script from "./ApprovalsFilter.vue?vue&type=script&lang=ts"
export * from "./ApprovalsFilter.vue?vue&type=script&lang=ts"
import style0 from "./ApprovalsFilter.vue?vue&type=style&index=0&id=647fb95a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647fb95a",
  null
  
)

export default component.exports